module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-notification",
    class: [{
      'cb-notification__warning': _vm.type == 'warning'
    }, {
      'cb-notification__soft-warning': _vm.type == 'soft_warning'
    }],
    style: (_vm.info && _vm.backgroundColor)
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cb-notification__content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-notification__icon"
  }, [_c('i', {
    staticClass: "icon-info-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d437a5f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/elements/Notification.vue
// module id = 674
// module chunks = 84